import logo from '../assets/images/logo-pq.png';
import collectionsJson from "../data/collections.json"
import { useEffect } from "react"
import { Collection } from "../pages/home.page";
import { Link, useLocation } from "react-router-dom";

export function Footer() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [location])

    const year = new Date().getFullYear()
    return (
        <div className="container-fluid g-0">
            <div className="row g-0">
                <div className="col-12" style={{height: "100px"}}></div>
                <div className="col-12 col-lg-4 footer-block">
                    <img src={logo} className="img-fluid" />
                </div>
                <div className="col-12 col-lg-4 footer-block">
                {
                    (collectionsJson as Collection[]).map((c: Collection) => {
                        if (c.link) {
                            return (
                                <a key={c.shortName} className="text-decoration-none text-dark" rel="noreferrer" href={c.link} target="_blank"><h3 className="text-uppercase">{ c.name }</h3></a>
                            )
                        } else {
                            return (
                                <Link key={c.shortName} className="text-decoration-none text-dark" to={ "/collection/" + c.shortName }><h3 className="text-uppercase">{c.name}</h3></Link>
                            )
                        }
                    })
                }
                    <Link className="text-decoration-none text-dark" to="/bijoux"><h3 className="text-uppercase">Les Bijoux</h3></Link>
                    <Link className="text-decoration-none text-dark" to="/bridal"><h3 className="text-uppercase">Bridal</h3></Link>
                    <Link className="text-decoration-none text-dark" to="/celebrities"><h3 className="text-uppercase">Celebrities</h3></Link>
                </div>
                <div className="col-12 col-lg-4 footer-block">
                    <h3><Link to="/trunkshows">TRUNK SHOWS</Link></h3>
                    <h3><Link to="/about">ABOUT US</Link></h3>
                    <h3><a target="_blank" rel="noreferrer" href="https://www.instagram.com/paola_quadretti/">INSTAGRAM</a></h3>
                </div>
            </div>
            <div className="d-flex justify-content-center my-4">
                <div className="text-center" style={{color: "gray"}}>
                    <p style={{color: "black"}} className="mb-4"><small>copyright © www.paolaquadretti.it {year}</small></p>
                    <p className="mb-0"><small>Piquadri Srl</small></p>
                    <p className="mb-0"><small>Sede legale via santo spirito 11 Firenze 50125</small></p>
                    <p className="mb-0"><small>Cod. fisc o P.Iva 06101730486</small></p>
                    <p className="mb-0"><small>Capitale sociale 100.000,00 parte versata 25.000,00</small></p>
                    <p className="mb-0"><small>Reg. Imp. FIRENZE e 06101730486</small></p>
                    <p className="mb-0"><small>REA FI-600473</small></p>
                </div>
            </div>
        </div>
    )
}